/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  .fill-1 {
    fill: #1c1e2b;
  }
  .fill-2 {
    fill: #fff;
  }
`

export default class IcehockeyTabIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="50.004" height="36.488" viewBox="0 0 50.004 36.488" css={Color}>
          <g id="그룹_4783" data-name="그룹 4783" transform="translate(-535.379 -1146.154)">
            <path id="패스_4575" className="fill-2" data-name="패스 4575" d="M585.383,1156.8c0-2.73-2.307-5.3-6.487-7.222-4.233-2.015-10.489-3.251-17.16-3.4l-.618-.018q-.732-.023-1.464,0l-.625.018c-6.67.145-12.925,1.381-17.15,3.389-4.189,1.93-6.5,4.5-6.5,7.227a1.864,1.864,0,0,0,.012.24,1.382,1.382,0,0,0-.012.182v10.142a12.669,12.669,0,0,0,5.888,10.73c4.076,2.849,11.216,4.55,19.116,4.55s15.044-1.7,19.078-4.527a12.691,12.691,0,0,0,5.922-10.753v-10.142a1.573,1.573,0,0,0-.013-.182C585.378,1156.959,585.383,1156.879,585.383,1156.8Z" fill="#fff" />
            <path id="패스_4760" className="fill-1" data-name="패스 4760" d="M560.384,1147.168c13.254,0,24,4.78,24,10.677s-10.746,10.676-24,10.676-24-4.78-24-10.676S547.129,1147.168,560.384,1147.168Z" fill="#1c1e2b" />
            <g id="타원_461-2" data-name="타원 461-2">
              <ellipse id="타원_464" className="fill-2" data-name="타원 464" cx="22.143" cy="8.82" rx="22.143" ry="8.82" transform="translate(538.239 1148.097)" fill="#fff" />
            </g>
          </g>
        </svg>
      </Fragment>
    )
  }
}
